import {
  QUICK_FILTER_SOURCE,
  buildDimensionAndFilters,
  buildMetricAndFilters,
  dimensionRuleItem,
  metricRuleItem,
} from "../quickFilterUtils";

const PRESET_CREATED_AT = "2026-01-01T00:00:00.000Z";

/**
 * @param {"metrics"|"dimension"} section
 * @param {{ id: string, name: string, description?: string, member: string, operator: string, values: any[] }} rule
 */
export const createSingleRuleSystemPreset = (pageId, platform, section, rule) => {
  const resolvedValues =
    typeof rule.values === "function" ? rule.values() : rule.values;
  const ruleItem =
    section === "metrics"
      ? metricRuleItem(rule.member, rule.operator, resolvedValues)
      : dimensionRuleItem(rule.member, rule.operator, resolvedValues);

  return {
    id: `system_${rule.id}_${pageId}_${platform}`,
    name: rule.name,
    description: rule.description || rule.name,
    source: QUICK_FILTER_SOURCE.SYSTEM,
    createdAt: PRESET_CREATED_AT,
    updatedAt: PRESET_CREATED_AT,
    filterModuleFilters:
      section === "metrics"
        ? buildMetricAndFilters([ruleItem])
        : buildDimensionAndFilters([ruleItem]),
  };
};

export const createSystemPresetsFromRules = (pageId, platform, rules = []) =>
  rules.map(({ section, ...rule }) =>
    createSingleRuleSystemPreset(pageId, platform, section, rule)
  );
